export class DeviceType {
    constructor(
        public DeviceTypeCode: string,
        public DeviceTypeDescription: string
    ){}
}